/**
 * Resolves an operation on a generated Swagger client that the target backend may not serve yet.
 *
 * `src/api` is generated from whichever backend the build points at, so an operation the frontend
 * has already been written against is simply absent from the client until that backend deploys it
 * — and calling it throws `… is not a function` at runtime, usually swallowed by a `catch` that
 * leaves the feature silently empty. Resolving the method through here lets a caller answer the
 * request some other way meanwhile, and pick up the real endpoint the moment it appears, with no
 * further change.
 */
export const optionalApiMethod = <TMethod extends (...args: never[]) => unknown>(
  api: object,
  name: string,
): TMethod | undefined => {
  const method = (api as Record<string, unknown>)[name];
  return typeof method === 'function' ? (method.bind(api) as TMethod) : undefined;
};
